module.exports = __webpack_public_path__ + "img/tu2.127736a5.png";